import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { Grid } from '@/common/grid/Grid';
import { parseFormulaParts } from '@/md/entities/priceRes/formFields/PriceResFormulaUtils';
import { useRef } from 'react';

const fieldDefs = [
  { field: 'code', displayName: 'Variables' },
  { field: 'value', displayName: 'Value' },
];

// Renders the values (sourced from tierVars' JSON) for every var the Prog measured for this period,
// formatted like the standard entity grids (ex: ProgList, PriceResList). Vars the resolved Tier's formula
// does not reference are listed too - they are what a higher Tier was gated on and failed to clear.
export const PriceResVarsList = () => {
  const { entityObj } = useEntityMgr();
  const gridRef = useRef();

  let codeToValue = {};
  try {
    codeToValue = entityObj.tierVars ? JSON.parse(entityObj.tierVars) : {};
  } catch {
    codeToValue = {};
  }

  const formulaCodes = parseFormulaParts(entityObj.tierFormula)
    .map((part) => part.code)
    .filter(Boolean);

  const codes = [...new Set([...formulaCodes, ...Object.keys(codeToValue)])];

  const rows = codes.map((code) => ({ code, value: codeToValue[code] ?? '0' }));

  const onGridReady = () => {
    gridRef.current.setDataSource(rows);
  };

  return (
    <Grid
      ref={gridRef}
      gridOptions={{ fieldDefs, rowModelType: 'clientSide', statusBar: null }}
      events={{ onGridReady }}
    />
  );
};
